import { useAuth } from '@/app/hooks/auth-provider';
import { useSecurityContext } from '@/app/hooks/security-provider';
import type { StaffMemberModel, StaffRoleEnum } from '@/app/types/staff-member.type';
import { UserTypeEnum } from '@/app/types/user-type';

type Props = {
  children?: React.ReactNode;
  renderOnFail?: React.ReactNode;
  accountId?: number;
  allowedUserTypes?: UserTypeEnum[];
  minimumStaffRole?: StaffRoleEnum;
  additionalCheck?: boolean;
};

export default function SecurityCheck({
  children,
  renderOnFail,
  accountId,
  allowedUserTypes,
  minimumStaffRole,
  additionalCheck,
}: Props) {
  const { user } = useAuth();
  const { currentAccount } = useSecurityContext();
  const _accountId = accountId ?? currentAccount?.id;
  const userIsAdmin = user?.userType === UserTypeEnum.Admin;

  if (additionalCheck !== undefined && !additionalCheck) {
    return renderOnFail ?? null;
  }

  if (allowedUserTypes && allowedUserTypes.length && !allowedUserTypes.includes(user?.userType)) {
    return renderOnFail ?? null;
  }

  if (allowedUserTypes && allowedUserTypes.includes(UserTypeEnum.Admin) && userIsAdmin) {
    return children;
  }

  if (user?.userType === UserTypeEnum.StaffMember && _accountId) {
    const _currentStaffUser = user as StaffMemberModel;
    const staffAccount = _currentStaffUser?.accountSiteStaffMembers.find(
      x => x.accountId === _accountId,
    );
    if (!staffAccount) {
      return renderOnFail ?? null;
    }
    if (minimumStaffRole && staffAccount?.staffRole.id < minimumStaffRole) {
      return renderOnFail ?? null;
    }
  }

  return children;
}
